module.exports = __webpack_public_path__ + "img/enterprise-competition-2024-schedule-open-group-1.5b90ce08.jpg";